var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnimals = function SvgAnimals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.95 109.95"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "animals_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "animals_svg__cls-1",
    d: "M22.67 48a28.31 28.31 0 0156.62 0v11.87H22.67z"
  })), /*#__PURE__*/React.createElement("style", null, ".animals_svg__cls-1{fill:#b98d6c}.animals_svg__cls-6{fill:none;stroke-miterlimit:10;stroke-width:6px}.animals_svg__cls-4{fill:#007670}.animals_svg__cls-6{stroke:#007670}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "animals_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "animals_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.97,
    cy: 54.97,
    r: 54.97,
    fill: "#f3b26e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.25 56.87H87.6A1.85 1.85 0 0089.45 55V45",
    strokeLinecap: "round",
    stroke: "#00ad6c",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animals_svg__cls-4",
    cx: 84.82,
    cy: 46.26,
    r: 1.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animals_svg__cls-4",
    cx: 94.1,
    cy: 46.26,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "animals_svg__cls-1",
    d: "M22.67 48a28.31 28.31 0 0156.62 0v11.87H22.67z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#animals_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "animals_svg__cls-6",
    cx: 55.7,
    cy: 59.87,
    r: 8.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animals_svg__cls-6",
    cx: 65.85,
    cy: 25.16,
    r: 16.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animals_svg__cls-6",
    cx: 25.66,
    cy: 38.02,
    r: 11.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.29 79.43V59.87M64.34 79.43V59.87M25.67 79.43V59.87m11.95 19.56V59.87",
    stroke: "#00ad6c",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })))));
};
export { SvgAnimals as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDkuOTUgMTA5Ljk1Ij48ZGVmcz48Y2xpcFBhdGggaWQ9ImFuaW1hbHNfc3ZnX19jbGlwLXBhdGgiPjxwYXRoIGNsYXNzPSJhbmltYWxzX3N2Z19fY2xzLTEiIGQ9Ik0yMi42NyA0OGEyOC4zMSAyOC4zMSAwIDAxNTYuNjIgMHYxMS44N0gyMi42N3oiLz48L2NsaXBQYXRoPjxzdHlsZT4uYW5pbWFsc19zdmdfX2Nscy0xe2ZpbGw6I2I5OGQ2Y30uYW5pbWFsc19zdmdfX2Nscy02e2ZpbGw6bm9uZTtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6NnB4fS5hbmltYWxzX3N2Z19fY2xzLTR7ZmlsbDojMDA3NjcwfS5hbmltYWxzX3N2Z19fY2xzLTZ7c3Ryb2tlOiMwMDc2NzB9PC9zdHlsZT48L2RlZnM+PGcgaWQ9ImFuaW1hbHNfc3ZnX19MYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJhbmltYWxzX3N2Z19fTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxjaXJjbGUgY3g9IjU0Ljk3IiBjeT0iNTQuOTciIHI9IjU0Ljk3IiBmaWxsPSIjZjNiMjZlIi8+PHBhdGggZD0iTTczLjI1IDU2Ljg3SDg3LjZBMS44NSAxLjg1IDAgMDA4OS40NSA1NVY0NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2U9IiMwMGFkNmMiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI2Ii8+PGNpcmNsZSBjbGFzcz0iYW5pbWFsc19zdmdfX2Nscy00IiBjeD0iODQuODIiIGN5PSI0Ni4yNiIgcj0iMS42NCIvPjxjaXJjbGUgY2xhc3M9ImFuaW1hbHNfc3ZnX19jbHMtNCIgY3g9Ijk0LjEiIGN5PSI0Ni4yNiIgcj0iMS42NCIvPjxwYXRoIGNsYXNzPSJhbmltYWxzX3N2Z19fY2xzLTEiIGQ9Ik0yMi42NyA0OGEyOC4zMSAyOC4zMSAwIDAxNTYuNjIgMHYxMS44N0gyMi42N3oiLz48ZyBjbGlwLXBhdGg9InVybCgjYW5pbWFsc19zdmdfX2NsaXAtcGF0aCkiPjxjaXJjbGUgY2xhc3M9ImFuaW1hbHNfc3ZnX19jbHMtNiIgY3g9IjU1LjciIGN5PSI1OS44NyIgcj0iOC42NCIvPjxjaXJjbGUgY2xhc3M9ImFuaW1hbHNfc3ZnX19jbHMtNiIgY3g9IjY1Ljg1IiBjeT0iMjUuMTYiIHI9IjE2Ljg5Ii8+PGNpcmNsZSBjbGFzcz0iYW5pbWFsc19zdmdfX2Nscy02IiBjeD0iMjUuNjYiIGN5PSIzOC4wMiIgcj0iMTEuNiIvPjwvZz48cGF0aCBkPSJNNzYuMjkgNzkuNDNWNTkuODdNNjQuMzQgNzkuNDNWNTkuODdNMjUuNjcgNzkuNDNWNTkuODdtMTEuOTUgMTkuNTZWNTkuODciIHN0cm9rZT0iIzAwYWQ2YyIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjYiLz48L2c+PC9nPjwvc3ZnPg==";